export const PROFILE = {
  name: "Jesal Sharma",
  photo: "https://framerusercontent.com/images/hYhfmUyYTJ9FudNcq7kaW5tyQ.jpg?width=800&height=995",
  email: "jesalsharma07@gmail.com",
  linkedin: "https://www.linkedin.com/in/jesal-sharma/",
  calendly: "https://calendly.com/jesalsharma07/30min",
};

export const HERO = {
  greeting: "I'm Jesal Sharma",
  headline: "Product Manager with 5+ years of experience specializing in B2B SaaS and Enterprise platforms.",
  sub: "From discovery to launch, I bridge the gap between business goals and user needs — leading teams to ship products that solve real problems and drive business outcomes.",
};

export const TOOLS = [
  { name: "Slack", logo: "https://cdn.svgporn.com/logos/slack-icon.svg" },
  { name: "Jira", logo: "https://cdn.svgporn.com/logos/jira.svg" },
  { name: "Miro", logo: "https://cdn.svgporn.com/logos/miro.svg" },
  { name: "Monday.com", logo: "https://cdn.svgporn.com/logos/monday-icon.svg" },
  { name: "Confluence", logo: "https://cdn.svgporn.com/logos/confluence.svg" },
  { name: "Notion", logo: "https://cdn.svgporn.com/logos/notion-icon.svg" },
  { name: "Atlassian", logo: "https://cdn.svgporn.com/logos/atlassian.svg" },
  { name: "Figma", logo: "https://cdn.svgporn.com/logos/figma.svg" },
  { name: "Framer", logo: "https://cdn.svgporn.com/logos/framer.svg" },
  { name: "Power BI", logo: "https://cdn.svgporn.com/logos/microsoft-power-bi.svg" },
  { name: "Salesforce", logo: "https://cdn.svgporn.com/logos/salesforce.svg" },
];

export const EXPERTISE = {
  eyebrow: "Skills & Experience Areas",
  title: "A blend of strategic thinking, technical knowledge and a user-centric approach that drives product success.",
  areas: [
    {
      name: "Product Management",
      body: "Leading 0→1 product development through the full lifecycle — from user research and roadmap prioritization to launch and adoption. Expert in Agile methodologies, stakeholder alignment, and delivering data-driven solutions that drive measurable business outcomes.",
      skills: [
        "Feature Prioritization",
        "Customer Discovery",
        "Product Strategy",
        "Agile Delivery",
        "Roadmapping",
        "PRD & User Stories",
      ],
      stats: [
        { value: "1500+", label: "Users Onboarded" },
        { value: "40%", label: "Workflow Efficiency Improved" },
        { value: "60%", label: "Faster Reporting" },
        { value: "0→1", label: "Products Shipped" },
      ],
    },
    {
      name: "Business Strategy & Planning",
      body: "Translating market insight into actionable growth strategy. I run competitive, PESTLE and financial analyses to identify expansion opportunities, define go-to-market roadmaps, and align KPIs with business objectives for sustainable, measurable growth.",
      skills: [
        "Market Research",
        "Competitive Analysis",
        "GTM Strategy",
        "Financial Modeling",
        "PESTLE / SWOT",
        "OKR Planning",
      ],
      stats: [
        { value: "3", label: "New Markets Identified" },
        { value: "5-Yr", label: "Financial Assessment" },
        { value: "4P", label: "Marketing Mix Defined" },
        { value: "25%", label: "Faster Turnaround" },
      ],
    },
    {
      name: "Customer Success",
      body: "Driving adoption, retention and satisfaction across enterprise accounts. I partner closely with clients to deliver tailored solutions, reduce support load, and turn feedback into product improvements that lift NPS and long-term engagement.",
      skills: [
        "Stakeholder Management",
        "Onboarding & Adoption",
        "Account Strategy",
        "Retention",
        "SLA Management",
        "Voice of Customer",
      ],
      stats: [
        { value: "85%", label: "Client NPS Achieved" },
        { value: "350+", label: "Enterprise Clients" },
        { value: "50%", label: "Fewer Support Requests" },
        { value: "90%", label: "Client Engagement" },
      ],
    },
  ],
};

export const EXPERIENCE = [
  {
    company: "CloudMasters Computing",
    role: "Product Manager",
    period: "Present",
    logo: "https://static.prod-images.emergentagent.com/jobs/db3c01c6-a597-4105-863e-3e3bf959e77e/images/b25b102b0377420187a6e1b723e6c4749af561ba93be2a4f2bedf4433213a22a.png",
    points: [
      "Led 0-to-1 development of a CRM platform for Community Living organizations, owning product vision, discovery, roadmap, and backlog; grew it from 1 client to 10+ paying organizations and 1,500+ end users.",
      "Wrote PRDs, user stories, and acceptance criteria for every release, running Agile sprint planning and backlog refinement with a team of 5+ engineers.",
      "Cut manual data entry by ~40% and reporting time by 60% by launching Intelligent Document Processing, automated analytics dashboards and AI-powered integrations.",
      "Ran 50+ discovery interviews with care staff and administrators across all client organizations, identifying untracked support-plan goals as the shared top pain and prioritizing goal tracking with daily progress logging on the roadmap.",
      "Defined product KPIs and adoption metrics with leadership to measure product success monthly, derive insights to inform product strategy and planning, and align roadmap priorities with business goals.",
    ],
  },
  {
    company: "Citrix Systems",
    role: "Customer Success Lead",
    period: "Prior",
    logo: "https://cdn.simpleicons.org/citrix/452170",
    points: [
      "Drove product adoption and technical success for 350+ enterprise clients across Endpoint Management (XenMobile) and Content Collaboration (ShareFile) platforms.",
      "Identified recurring XenMobile upgrade failures across NA and EMEA enterprise accounts and converted the patterns into engineering tickets, cutting upgrade-related support volume by 20%.",
      "Root-caused a ShareFile Outlook plugin failure affecting users with multiple email profiles and drove the fix through engineering, restoring functionality for 5K+ enterprise accounts.",
      "Maintained 85% quarterly CSAT by delivering tailored technical solutions, driving proactive stakeholder communication, and turning field escalations into actionable engineering tickets.",
      "Collaborated with Engineering teams to convert recurring enterprise customer feedback into product requirements and feature recommendations adopted into product release planning cycles.",
    ],
  },
];

// Summary cards for the Projects section (full content in projectsData.js)
export const PROJECTS = [
  {
    slug: "ai-post-call",
    title: "AI-Powered Post-Call Product-Led Strategy",
    category: "Software Development",
    tags: ["Product Strategy", "User Research", "AI / ML"],
    summary: "A product-led strategy to streamline post-call workflows for technical sales teams.",
    thumb: "https://framerusercontent.com/images/HH6KjvaovebOIdq46oRjg7XPs0.webp?width=1200&height=630",
  },
  {
    slug: "community",
    title: "CommUnity — Social Platform for Students",
    category: "Social Networking",
    tags: ["MVP Strategy", "User Research", "Go-To-Market"],
    summary: "A mobile-first social platform addressing cultural isolation for international students.",
    thumb: "https://framerusercontent.com/images/hJcR2l79WIANAbewoSaFfDQNYhc.png?width=1536&height=1024",
  },
  {
    slug: "market-expansion",
    title: "Market Expansion Strategy — Renewable Energy",
    category: "Energy & Utilities",
    tags: ["Market Expansion", "Financial Analysis", "GTM Strategy"],
    summary: "Identifying high-potential South American markets for renewable energy expansion.",
    thumb: "https://framerusercontent.com/images/9qJAo2mmecyr9WeSPdmq9d8TU0.png?width=1200&height=600",
  },
  {
    slug: "growth-strategy",
    title: "Growth Strategy — Global Payments Platform",
    category: "Fintech",
    tags: ["Growth Strategy", "Competitive Analysis", "Market Research"],
    summary: "A comprehensive growth strategy for a payment-processing leader across new markets.",
    thumb: "https://framerusercontent.com/images/wQRXqH72IP7yyWAfcD4vqHbH0M.jpg?width=1323&height=693",
  },
];
